module.exports = __webpack_public_path__ + "static/media/NRLFantasyLogoMenu.0392126c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NRLFantasyLogoMenu.png
// module id = 1408
// module chunks = 0